import React, {useEffect, useState} from 'react'
import {Content} from '../../../_metronic/layout/components/content'
import {KTIcon} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import RoutesTable from './components/RoutesTable'
import {useRouteConfig} from './ConfigRoutesProvider'
import DeleteRouteConfig from './components/DeleteRouteConfig'
import InputSearchBox from '../../utils/components/form/InputSearchBox'

const RoutesList = () => {
  const {searchTerm, setSearchTerm, resetSelected} = useRouteConfig()

  const onCreate = () => resetSelected()

  useEffect(() => {
    resetSelected()
  }, [])

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <Link to='/routes/create-route' className='btn btn-primary' onClick={onCreate}>
            <KTIcon iconName='plus' className='fs-2' />
            Create Route
          </Link>
        </div>
      </div>

      <RoutesTable />
      <DeleteRouteConfig />
    </Content>
  )
}

export default RoutesList
